<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  methods: {
    getAppointment_channels () {
      this.$store.dispatch('getAppointment_channels')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAppointment_channels()
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Appointment_channels.vue?06a59698